import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import UserBadge from './UserBadge';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import {makeStyles} from '@material-ui/core/styles';
import {locationByID} from '../../app/models/ormSelectors';
import {selectActiveUser} from './dashboardSlice';

const StyledButton = styled(motion.button)`
  padding: 0;
  width: 58px;
  height: 58px;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
  cursor: pointer;
  position: relative;
  z-index: 100;
`

const StyledTopLabel = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  top: -1px;
  right: -2px;  
  z-index: 120;
  filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.08)) drop-shadow(0px 4px 24px rgba(58, 79, 79, 0.12));
`


const UserPin = ({user, index, showBatteryLevel, pending}) => {
    const {id, type} = user;
    const geoByID = useSelector(locationByID);
    const activeUser = useSelector(selectActiveUser);
    const isUserActive = id === activeUser;
    const deviceIcon = type === 'device' ? user.deviceIcon : '';

    const userStatus = geoByID(id);
    const opacityStyled = geoByID(user.id).locationStatus === 'OLDER_THAN_24H' ? '0.6' : '1';

    const useStyles = makeStyles({
        avatar: {
            width: '58px',
            height: '58px',
            opacity: opacityStyled,
            border: isUserActive ? '3px solid #00BFA5' : '3px solid transparent',
        }
    });

    const classes = useStyles();

    return (
        <StyledButton whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} id='continue-button'>
            {deviceIcon && <StyledTopLabel src={deviceIcon}/>}
            <UserBadge key={index} userID={id}
                       appStatus={userStatus.permissionsIssues}
                       locationStatus={userStatus.locationStatus}
                       batteryLevel={user.battery_level}
                       showBatteryLevel={showBatteryLevel}
                       pending={pending}
            >
                <Avatar alt={user.name} src={user.photo_url || '../images/default-static-avatar.png'} className={classes.avatar}/>
            </UserBadge>
        </StyledButton>)
};

export default UserPin;

